<template>
    <div class="testInt">
        <tabs
            :tabs="tabs.options"
            :active-tab="tabs.active"
            @selected="selectedTab"
            translate
            :loaded="tabLoader"
        >
            <ValidationObserver v-if="tabs.active === 0" ref="form" class="centerx default-input" v-slot="{handleSubmit}">
                <vs-row>
                    <vs-col vs-w="12">
                        <div class="p-2">
                            <ValidationProvider vid="offer" :name="$t('global.Offer')" rules="required" v-slot="{ errors }">
                                <div class="text-sm opacity-75">{{$t('global.Offer')}}</div>
                                <v-select
                                    class="w-full"
                                    :placeholder="$t('global.Offer')"
                                    :clearable="false"
                                    :options="options.offers"
                                    :reduce="item => item.id"
                                    appendToBody
                                    label="name"
                                    v-model="selected.offer_id"
                                    :calculate-position="withPopper"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="language" :name="$t('global.Language')" rules="required" v-slot="{ errors }">
                                <div class="text-sm opacity-75">{{$t('global.Language')}}</div>
                                <v-select
                                    class="w-full"
                                    :placeholder="$t('global.Language')"
                                    :clearable="false"
                                    :options="options.languages"
                                    :reduce="item => item.language"
                                    appendToBody
                                    label="language"
                                    :disabled="!selected.offer_id"
                                    v-model="selected.language"
                                    :calculate-position="withPopper"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="country" :name="$t('global.Country')" rules="required" v-slot="{ errors }">
                                <div class="text-sm opacity-75">{{$t('global.Country')}}</div>
                                <v-select
                                    class="w-full"
                                    :placeholder="$t('global.Country')"
                                    :clearable="false"
                                    :options="options.countries"
                                    :reduce="item => item"
                                    appendToBody
                                    label="name"
                                    v-model="selected.country"
                                    :calculate-position="withPopper"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-divider/>
                    <vs-col vs-w="12">
                        <div class="p-2">
                            <ValidationProvider vid="first_name" :name="$t('global.Name')" rules="string" v-slot="{ errors }">
                                <div class="text-sm opacity-75">{{$t('global.Name')}}</div>
                                <vs-input
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('global.Name')"
                                    v-model="selected.first_name"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="last_name" :name="$t('modals.Last_name')" rules="string" v-slot="{ errors }">
                                <div class="text-sm opacity-75">{{$t('modals.Last_name')}}</div>
                                <vs-input
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('modals.Last_name')"
                                    v-model="selected.last_name"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="phone" :name="$t('modals.Phone')" rules="phone|min:7|max:20" v-slot="{ errors }">
                                <div class="text-sm opacity-75">{{$t('modals.Phone')}}</div>
                                <vs-input
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('modals.Phone')"
                                    v-model="selected.phone"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="email" :name="$t('global.Email')" rules="email" v-slot="{ errors }">
                                <div class="text-sm opacity-75">{{$t('global.Email')}}</div>
                                <vs-input
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('global.Email')"
                                    v-model.trim="selected.email"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="ip" :name="$t('modals.IP')" rules="string|ip" v-slot="{ errors }">
                                <div class="text-sm opacity-75">{{$t('modals.IP')}}</div>
                                <vs-input
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('modals.IP')"
                                    v-model="selected.ip"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="campaigns_id" :name="$t('global.Campaign')" rules="" v-slot="{ errors }">
                                <div class="text-sm opacity-75">{{$t('global.Campaign')}}</div>
                                <v-select
                                    class="w-full"
                                    :placeholder="$t('global.Campaign')"
                                    :clearable="false"
                                    :options="options.campaigns"
                                    :reduce="item => item.id"
                                    appendToBody
                                    label="name"
                                    v-model="selected.campaigns_id"
                                    :calculate-position="withPopper"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6">
                        <div class="p-2">
                            <ValidationProvider vid="affiliate_id" :name="$t('global.Affiliate')" rules="" v-slot="{ errors }">
                                <div class="text-sm opacity-75">{{$t('global.Affiliate')}}</div>
                                <vs-input
                                    class="inputx w-full no_focus"
                                    :placeholder="$t('global.Affiliate')"
                                    disabled
                                    v-model="affiliateName"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>

                    <vs-col vs-w="4">
                        <div class="p-2">
                            <div class="text-sm opacity-75">sub1</div>
                            <vs-input
                              class="inputx w-full no_focus"
                              placeholder="sub1"
                              v-model="selected.sub1"
                            />
                        </div>
                    </vs-col>

                    <vs-col vs-w="4">
                        <div class="p-2">
                            <div class="text-sm opacity-75">sub2</div>
                            <vs-input
                              class="inputx w-full no_focus"
                              placeholder="sub2"
                              v-model="selected.sub2"
                            />
                          </div>
                    </vs-col>

                    <vs-col vs-w="4">
                        <div class="p-2">
                            <div class="text-sm opacity-75">sub3</div>
                            <vs-input
                              class="inputx w-full no_focus"
                              placeholder="sub3"
                              v-model="selected.sub3"
                            />
                        </div>
                    </vs-col>

                    <vs-col vs-w="4">
                        <div class="p-2">
                            <div class="text-sm opacity-75">sub4</div>
                            <vs-input
                              class="inputx w-full no_focus"
                              placeholder="sub4"
                              v-model="selected.sub4"
                            />
                        </div>
                    </vs-col>

                    <vs-col vs-w="4">
                        <div class="p-2">
                            <div class="text-sm opacity-75">sub5</div>
                            <vs-input
                              class="inputx w-full no_focus"
                              placeholder="sub5"
                              v-model="selected.sub5"
                            />
                        </div>
                    </vs-col>

                    <vs-col vs-w="4">
                        <div class="p-2">
                            <div class="text-sm opacity-75">sub6</div>
                            <vs-input
                              class="inputx w-full no_focus"
                              placeholder="sub6"
                              v-model="selected.sub6"
                            />
                        </div>
                    </vs-col>

                    <vs-col vs-w="4">
                        <div class="p-2">
                            <div class="text-sm opacity-75">sub7</div>
                            <vs-input
                              class="inputx w-full no_focus"
                              placeholder="sub7"
                              v-model="selected.sub7"
                            />
                        </div>
                    </vs-col>

                    <vs-col vs-w="4">
                        <div class="p-2">
                            <div class="text-sm opacity-75">sub8</div>
                            <vs-input
                              class="inputx w-full no_focus"
                              placeholder="sub8"
                              v-model="selected.sub8"
                            />
                        </div>
                    </vs-col>

                    <vs-col vs-w="4">
                        <div class="p-2">
                            <div class="text-sm opacity-75">sub9</div>
                            <vs-input
                              class="inputx w-full no_focus"
                              placeholder="sub9"
                              v-model="selected.sub9"
                            />
                        </div>
                    </vs-col>

                    <vs-col vs-w="12" v-if="response && Object.keys(response).length">
                        <div class="p-2">
                            <vs-alert style="overflow-y: auto" :title="response.success ? $t('global.send') : $t('global.not_send')" active="true" :color="response.success ? 'success' : 'danger'">
                                <div v-if="response.result.advertiser_history_response">
                                    <b class="p-4">{{$t('global.history_response')}}</b>
                                    <response :data="response.result.advertiser_history_response"></response>
                                </div>
                                <b class="p-4">{{$t('global.response')}}</b>
                                <response :data="response.result"></response>
                            </vs-alert>
                        </div>
                    </vs-col>

                    <vs-col vs-w="12">
                        <div class="p-2 text-center">
                            <vs-button @click="handleSubmit(submit)" :disabled="!buttonLoader" button="submit" ref="btn">{{ $t('buttons.Test') }}</vs-button>
                        </div>
                    </vs-col>
                </vs-row>
            </ValidationObserver>

            <validation-observer v-if="tabs.active === 1" ref="form" v-slot="{handleSubmit}">
                <vs-row vs-align="end">
                    <vs-col vs-w="9">
                        <div class="p-2">
                            <ValidationProvider vid="day" :name="$t('global.Day')" rules="required" v-slot="{ errors }">
                                <div class="text-sm opacity-75">{{$t('global.Day')}}</div>
                                <v-select
                                    class="w-full"
                                    :placeholder="$t('global.Day')"
                                    :clearable="false"
                                    :options="syncStatus.options"
                                    appendToBody
                                    v-model.number="syncStatus.select.days"
                                    :calculate-position="withPopper"
                                />
                                <span class="text-danger text-xs" >{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </vs-col>

                    <vs-col vs-w="3">
                        <div class="p-2">
                            <vs-button
                                class="w-full"
                                @click="handleSubmit(submitSyncStatus)"
                                :disabled="!buttonLoader"
                                button="submit"
                                ref="btn"
                            >{{ $t('buttons.Test') }}</vs-button>
                        </div>
                    </vs-col>
                </vs-row>
            </validation-observer>
        </tabs>

        <tabs
            v-if="responseTabs.options.length"
            :tabs="responseTabs.options"
            :active-tab="responseTabs.active"
            @selected="selectResponseTab"
            translate
            :transition="false"
            :loaded="tabLoader"
        >
            <div
                v-for="(value, key, index) in response"
                :key="key"
                v-if="response && Object.keys(response).length && responseTabs.active === index"
            >
                <status-response :data="value" />
            </div>
        </tabs>
    </div>
</template>

<script>
import ErrorHandler from "@/utils/errorHandler"
import send from '@/utils/fetch'
import vSelect from 'vue-select'
import Response from "./Response"
import {vSelectPosition} from "@/utils/mixins"
import StatusResponse from "@/views/settings/advertisers/components/Response.vue"

export default {
    props: ['popupData', 'popupType', 'popupButton'],
    mixins: [vSelectPosition],

    data() {
        return {
            tabLoader: false,
            tabs: {
                options: [
                    {name: 'tab.lead_test', event: 'lead_test'},
                    {name: 'tab.sync_status', event: 'sync_status'},
                ],
                active: 0,
                activeIndex: 0
            },
            responseTabs: {
                options: [],
                active: 0,
                activeIndex: 0
            },
            syncStatus: {
                options: [1, 5, 10, 15],
                select: {
                    days: 1
                }
            },
            buttonLoader: true,
            response: {},
            affiliateName: '',
            options: {
                offers: [],
                countries: [],
                languages: [],
                affiliate: {},
                campaigns: [],
            },
            selected: {
                offer_id: '',
                country: '',
                language: '',
                first_name: '',
                last_name: '',
                phone: '',
                affiliate_hash: '',
                email: '',
                ip: '',
                campaigns_id: '',
                advertisers_integration_id: '',
                sub1: '',
                sub2: '',
                sub3: '',
                sub4: '',
                sub5: '',
                sub6: '',
                sub7: '',
                sub8: '',
                sub9: ''
            },
            timeout: null
        }
    },

    components: {
        Response,
        vSelect,
        StatusResponse
    },

    methods: {
        selectResponseTab(index) {
            this.responseTabs.active = index
        },

        selectedTab(index) {
            this.response = {}
            this.responseTabs.options = []

            this.tabs.active = index
        },

        async submitSyncStatus() {
            const createResponseTabs = keys => keys.map(key => ({
                name: `tab.${key}`,
                event: key
            }))

            const response = await send(this.$url.advrtsr['check-sync'], 'POST', {data: {
                ...this.syncStatus.select, advertisers_integration_id: this.popupData.id
            }}).then(response => response.data.result)

            this.responseTabs.options = createResponseTabs(Object.keys(response))
            this.response = response
        },

        async getCheckData() {
            try {
                const params = {...this.selected}
                Object.keys(params).map(key => {
                    if (!params[key]) delete params[key]
                })

                const response = await send(this.$url.advrtsr["get-check-data"], 'GET', {params}).then(response => response.data.result)
                Object.keys(response).map(key => this.options[key] = response[key])

                this.$watch(() => this.selected.offer_id, id => {
                    this.selected.language = ''
                    const languages = response.offers.find(offer => +offer.id === +id).languages
                    if (languages) {
                        this.options.languages = languages
                    }
                })

                this.$watch(() => this.selected.language, language => {
                    this.selected.campaigns_id = ''
                    this.selected.affiliate = ''
                    this.affiliateName = ''
                    const campaigns = this.options.languages.find(lang => lang.language === language)
                    if (campaigns) {
                        this.options.campaigns = campaigns.campaigns
                    }
                })

                this.$watch(() => this.selected.campaigns_id, id => {
                    this.selected.affiliate_hash = ''
                    const affiliate = this.options.campaigns.find(comp => comp.id === id)
                    if (affiliate) {
                        this.options.affiliate = affiliate.affiliate
                        this.selected.affiliate = this.options.affiliate.hash
                        this.affiliateName = this.options.affiliate.name
                    }
                })
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        isJson(str) {
            try {
                return JSON.parse(str)
            } catch (e) {
                return false
            }
        },

        async submit() {
            try {
                this.response = {}
                this.buttonLoader = false
                const data = {...this.selected}
                Object.keys(data).map(key => {
                    if (!data[key]) delete data[key]
                })

                this.response = await send(this.$url.advrtsr.check, 'POST', {data})
                    .then(response => response.data)

                const json = this.isJson(this.response.result)
                if (json) {
                    this.response.result = json
                }

                this.buttonLoader = true
            } catch (e) {
                if(e.response && e.response.data && e.response.data.result) {
                    const response = e.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }

                this.buttonLoader = true
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        try {
            this.selected.advertisers_integration_id = this.popupData.id
            this.options.countries = this.popupData.countries

            await this.getCheckData()

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>
